/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { Version } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface VersionServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Create a New Version
     * Creates a new version.
     * @param version Version object that needs to be added
     */
    addVersion(version: Version, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Delete Version
     * Deletes a version by its ID.
     * @param versionId ID of the version to delete
     */
    deleteVersion(versionId: number, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Get All Versions (Ordered Asc)
     * Returns a list with all versions ordered by release date. The list is empty if no version exists.
     */
    findAllByOrderByReleasedateAsc(extraHttpRequestParams?: any): Observable<Array<Version>>;

    /**
     * Get All Versions (Ordered Desc)
     * Returns a list with all versions ordered by release date in descending order. The list is empty if no versions exist.
     */
    findAllByOrderByReleasedateDesc(extraHttpRequestParams?: any): Observable<Array<Version>>;

    /**
     * Get Current Software Version
     * Returns the current software version. An entity with the version number and the release date is always returned. The description and the ID are only included if the entry is stored in the database. If the data record is not stored in the database, the version number and the release date are taken from the software\&#39;s build information.
     */
    getCurrentVersion(extraHttpRequestParams?: any): Observable<Version>;

    /**
     * Get Version by ID
     * Returns a single version by its ID.
     * @param versionId ID of the version to return
     */
    getVersionById(versionId: number, extraHttpRequestParams?: any): Observable<Version>;

    /**
     * Update Existing Version
     * Updates an existing version.
     * @param versionId ID of the version to update
     * @param version Version object that needs to be updated
     */
    updateVersion(versionId: number, version: Version, extraHttpRequestParams?: any): Observable<{}>;

}
